import CommonOperationClass from '../../../commonOperationClass';

const zero = new CommonOperationClass('0');

export default zero;
